/**
 * Syringe specifications and constants
 * Single source of truth for all syringe-related data across the application
 */

// Input validation limits
export const INPUT_LIMITS = {
  MAX_PEPTIDE_MG: 1000,
  MAX_BAC_WATER_ML: 100,
  MIN_DOSE_MG: 0.01,
  MAX_DOSE_MG: 100,
  DECIMAL_PLACES_DOSE: 3,
  DECIMAL_PLACES_VOLUME: 2,
};

// Syringe specifications with display dimensions for SVG rendering
export const SYRINGE_SPECS = {
  '0.3ml': { units: 30, ml: 0.3, width: 60, height: 300 },
  '0.5ml': { units: 50, ml: 0.5, width: 70, height: 320 },
  '1ml': { units: 100, ml: 1, width: 80, height: 340 },
  '3ml': { units: 300, ml: 3, width: 90, height: 360 },
};

// Syringe options for dropdown menus
export const SYRINGE_OPTIONS = Object.entries(SYRINGE_SPECS).map(([value, spec]) => ({
  value,
  label: value === '3ml' ? '3 mL' : `${spec.ml} mL (${spec.units} units)`,
  max: spec.units,
}));

// Default syringe type
export const DEFAULT_SYRINGE_TYPE = '1ml';

// Preset concentration options for reconstitution calculator
export const PRESET_CONCENTRATIONS = [
  { label: '1 mg/mL', value: 1 },
  { label: '2 mg/mL', value: 2 },
  { label: '5 mg/mL', value: 5 },
  { label: '10 mg/mL', value: 10 },
];

// Preset dose options for dosage calculator
export const PRESET_DOSES = [
  { label: '0.25 mg', value: 0.25 },
  { label: '0.5 mg', value: 0.5 },
  { label: '1 mg', value: 1 },
  { label: '2 mg', value: 2 },
];
